import { render, staticRenderFns } from "./HeaderSmall.vue?vue&type=template&id=356a2ffe&scoped=true&"
import script from "./HeaderSmall.vue?vue&type=script&lang=js&"
export * from "./HeaderSmall.vue?vue&type=script&lang=js&"
import style0 from "./HeaderSmall.vue?vue&type=style&index=0&id=356a2ffe&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "356a2ffe",
  null
  
)

export default component.exports